import styled, { css } from "styled-components";
import PropTypes from "prop-types";

const Button = ({
  children,
  onClick,
  type = "button",
  variant = "default",
  size = "large",
  className = "",
  disabled = false,
  width = "auto",
  isLoading = false,
  textAlign = "center",
  margin = [0, 0, 0, 0],
  title = "",
  testId = "button",
}) => {
  return (
    <StyledButtonWrapper
      type={type}
      onClick={onClick}
      variant={variant}
      className={className}
      disabled={disabled}
      width={width}
      size={size}
      isLoading={isLoading}
      textAlign={textAlign}
      margin={margin}
      title={title}
      data-testid={testId}
    >
      {isLoading && (
        <StyledButtonSpinner
          src={variant === "secondary" ? "/spinner.svg" : "/spinner-white.svg"}
          alt="Loading"
        />
      )}
      {children}
    </StyledButtonWrapper>
  );
};

const StyledButtonSpinner = styled.img`
  margin-right: 8px;
  vertical-align: middle;
`;

const StyledButtonWrapper = styled.button`
  border-color: transparent;
  background: #007aff;
  color: #fff;
  cursor: pointer;
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `};
  ${(props) =>
    props.size === "large" &&
    css`
      height: 44px;
      ${StyledButtonSpinner} {
        height: 24px;
        width: 24px;
      }
    `};
  ${(props) =>
    props.size === "medium" &&
    css`
      height: 32px;
      font-size: 14px;
      border-radius: 6px;
      padding: 0 12px;
      ${StyledButtonSpinner} {
        height: 16px;
        width: 16px;
      }
    `};
  ${(props) =>
    props.size === "small" &&
    css`
      height: 24px;
      font-size: 12px;
      border-radius: 4px;
      padding: 0 8px;
      ${StyledButtonSpinner} {
        height: 12px;
        width: 12px;
      }
    `};
  ${(props) =>
    props.variant === "secondary" &&
    css`
      background: transparent;
      color: #007aff;
      border-color: #007aff;
    `};
  ${(props) =>
    props.variant === "nude" &&
    css`
      border: none;
      background: transparent;
      color: #007aff;
    `};
  ${(props) =>
    props.variant === "icon" &&
    css`
      background: transparent;
      color: #007aff;
      padding: 0 8px;
      height: auto;
    `};
  ${(props) =>
    props.variant === "circle" &&
    css`
      border-radius: 22px;
    `};
  ${(props) =>
    props.variant === "circle-outline" &&
    css`
      border-radius: 22px;
      border-color: #007aff;
      background: #fff;
      color: #007aff;
    `};
  ${(props) =>
    props.isLoading &&
    css`
      pointer-events: none;
    `};
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.33;
      cursor: not-allowed;
    `};
  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `};
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
`;

Button.propTypes = {
  padding: PropTypes.arrayOf(PropTypes.number),
  margin: PropTypes.arrayOf(PropTypes.number),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "outlined",
    "nude",
    "icon",
    "circle",
    "circle-outline",
  ]),
  textAlign: PropTypes.oneOf(["left", "right", "center"]),
  display: PropTypes.oneOf(["block", "inline-block"]),
  type: PropTypes.oneOf(["button", "submit"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
};

export default Button;
